module.exports = __webpack_public_path__ + "static/media/mv.a6d57d90.jpg";